import fetchBasicActionsFor from './basicActionsFor'
import { FetchAction, isFetchErrorAction, isFetchSuccessAction } from './model'

export type FetchState<T> = {
  isFetching: boolean,
  resources?: T,
  error?: any
}

export const fetchInitialState = {
  isFetching: false,
  resources: undefined,
  error: undefined
}

function fetchReducerFor<T>(resourceName: string, prefix?: string, origin?: string) {
  if (resourceName === null) throw new Error('fetchReducerFor: Expected resourceName')

  const actionTypes = fetchBasicActionsFor(resourceName, prefix)

  return function reducer(state: FetchState<T> = fetchInitialState, action: FetchAction<T>): FetchState<T> {
    if (action.origin !== origin) return {...state}

    switch (action.type) {
      case actionTypes.fetchStart:
        return {...state, isFetching: true, resources: undefined}

      case actionTypes.fetchSuccess:
        if (isFetchSuccessAction(action)) {
          const resources = action.payload.resources
          return {...state, isFetching: false, resources: resources, error: undefined}
        }
        return {...state}

      case actionTypes.fetchError:
        if (isFetchErrorAction(action)) return {...state, isFetching: false, error: action.payload.error}
        return {...state}

      default:
        return {...state}
    }
  }
}

export default fetchReducerFor
